<app-keenicon name="arrow-up" type="solid" class="text-white fs-3"></app-keenicon>